(function ($) {
    var Sage = {
        'common': {
            init: function () {
                if (!window.location.origin) {
                    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                }

                this.toggleMenuBtn();
                this.menuShowToScroll();
                this.newsBoxes();
                this.applyingJob();
                this.customSelectField();
                this.xsScreen();
                this.setup_pdf();
                this.showGallery();
                this.accordion();
                this.imgContext();
            },

            imgContext: function () {
                $('.front-page-carousel .carousel-inner .item, .introduction, svg, .page-header, .picture-box, .article-banner, img').bind('contextmenu', function (e) {
                    return false;
                });
            },
            accordion: function () {
                var target;
                $('.panel-group').on('shown.bs.collapse', function (e) {
                    var target = $(e.target).parent().offset().top;

                    if (window.innerWidth < 992) {
                        target -= 70;
                    }

                    $('html, body').animate({
                        scrollTop: target + 'px'
                    });
                });
            },
            slickSlider: function(){
                $('#gallery-carousel').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    asNavFor: '#gallery-carousel-nav',
                    nextArrow: '<div class="slick-slider-arrows right"><div class="icon-wrap"><span class="icon-arrow-right"></span></div></div>',
                    prevArrow: '<div class="slick-slider-arrows left"><div class="icon-wrap"><span class="icon-arrow-left"></span></div></div>',
                    fade: true,
                    adaptiveHeight: true
                });
                $('#gallery-carousel-nav').slick({
                    slidesToShow: 9,
                    slidesToScroll: 1,
                    arrows: false,
                    asNavFor: '#gallery-carousel',
                    centerMode: true,
                    focusOnSelect: true,
                    responsive: [{
                      breakpoint: 480,
                      settings: {slidesToShow: 5, slidesToScroll: 1}
                  }]
              });
            },
            showGallery: function () {
                $('.btn.btn-gallery').on('click', function (e) {
                    e.preventDefault();
                    var gallery_id = $(this).data('gallery');
                    $.ajax({
                        method: 'POST',
                        url: sage.ajaxurl,
                        dataType: 'html',
                        beforeSend: function () {
                            if ($('#modal-window .modal-header .modal-title').length) {
                                $('#modal-window .modal-header .modal-title').text('Galéria betöltése...');
                            } else {
                                $('#modal-window .modal-header').prepend('<h4 class="modal-title">Galéria betöltése...</h4>');
                            }
                            $('#modal-window .modal-body').html('<div class="loading-toolbar"><div class="loading-bar"><div class="progress-sign"></div></div></div>');
                            $('#modal-window').modal('show');
                        },
                        data: {
                            action: 'display_gallery',
                            gallery_id: gallery_id
                        }
                    }).done(function (response) {
                        $('#modal-window .modal-body').html(response);

                        var title = $('#gallery-carousel').data('title');
                        $('#modal-window .modal-header .modal-title').text(title);
                        setTimeout(function(){
                            Sage.common.slickSlider();
                        }, 300);
                        
                    });
                });
            },
            setup_pdf: function () {

                $('.load-pdf-btn').on('click', function (e) {
                    e.preventDefault();

                    var PDFcanvas = $('<canvas id="pdf-reader"></canvas>');
                    PDFcanvas.on('contextmenu', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    });

                    var PDFtoolbar = [
                    '<div class="btn-group pdf-toolbar">',
                    '<div class="btn-group">',
                    '<button class="btn btn-toolbar-left" id="prev"></button>',
                    '<button class="btn btn-toolbar-zoom" id="zoom"></button>',
                    '<button class="btn btn-toolbar-zoomout" id="zoomout"></button>',
                    '<button class="btn btn-toolbar-right" id="next"></button>',
                    '</div>',
                    '</div>',
                    '<span class="pdf-page-info">Oldal: <span id="page_num"></span> / <span id="page_count"></span></span>',
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>'
                    ];

                    $('#modal-window .modal-header').html(PDFtoolbar.join(''));
                    var canvasWrap = $('<div class="canvas-wrap"></div>');
                    var loadingBarWrap = $('<div class="loading-bar-wrap"></div>');
                    canvasWrap.html(PDFcanvas);
                    $('#modal-window .modal-body').html(canvasWrap);
                    $('#modal-window .modal-body .canvas-wrap').hide();
                    $('#modal-window .modal-body').append(loadingBarWrap);
                    $('#modal-window').modal('show');

                    var pdf_doc_url = $(this).data('url');
                    Sage.common.pdf_controller(pdf_doc_url);

                    $('#modal-window').modal('show');

                });

            },
            pdf_controller: function (pdf_doc_url) {
                var url = pdf_doc_url;

                PDFJS.workerSrc = window.location.origin + '/app/themes/mtd/pdf_js/pdf.worker.js';
                var pdfDoc = null,
                pageNum = 1,
                pageRendering = false,
                pageNumPending = null,
                scale = 1.3,
                canvas = document.getElementById('pdf-reader'),
                ctx = canvas.getContext('2d');

                function renderPage(num) {
                    pageRendering = true;
                    pdfDoc.getPage(num).then(function (page) {
                        var viewport = page.getViewport(scale);
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        var renderContext = {
                            canvasContext: ctx,
                            viewport: viewport
                        };
                        var renderTask = page.render(renderContext);

                        renderTask.promise.then(function () {
                            pageRendering = false;
                            if (pageNumPending !== null) {
                                renderPage(pageNumPending);
                                pageNumPending = null;
                            }
                        });
                    });

                    document.getElementById('page_num').textContent = pageNum;
                }

                function queueRenderPage(num) {
                    if (pageRendering) {
                        pageNumPending = num;
                    } else {
                        renderPage(num);
                    }
                }
                function onPrevPage() {
                    if (pageNum <= 1) {
                        return;
                    }
                    pageNum--;
                    queueRenderPage(pageNum);
                }
                document.getElementById('prev').addEventListener('click', onPrevPage);

                function onNextPage() {
                    if (pageNum >= pdfDoc.numPages) {
                        return;
                    }
                    pageNum++;
                    queueRenderPage(pageNum);
                }
                document.getElementById('next').addEventListener('click', onNextPage);

                function onZoom() {
                    if ((scale + 0.2) <= 2) {
                        scale += 0.2;
                        queueRenderPage(pageNum);
                    } else {
                        return false;
                    }
                }
                document.getElementById('zoom').addEventListener('click', onZoom);
                function onZoomOut() {
                    if ((scale - 0.2) >= 0.8) {
                        scale -= 0.2;
                        queueRenderPage(pageNum);
                    } else {
                        return false;
                    }
                } 
                document.getElementById('zoomout').addEventListener('click', onZoomOut);

                PDFJS.getDocument(url, null, null, function (progress) {
                    var percent = (Math.round(progress.loaded / progress.total * 10)) * 10;

                    $('#modal-window .modal-body .loading-bar-wrap').html('<div class="loader-container"><div class="ajax-loader-logo"></div></div>');

                    $('.ajax-loader-logo').text('PDF betöltése... ' + percent + '%');

                    if (percent >= 100) {
                        $('#modal-window .modal-body .canvas-wrap').show();
                        $('#modal-window .modal-body .loading-bar-wrap').remove();
                    }

                }).then(function (pdfDoc_) {
                    pdfDoc = pdfDoc_;
                    document.getElementById('page_count').textContent = pdfDoc.numPages;
                    renderPage(pageNum);
                });
            },
            customSelectField: function () {
                if (document.getElementsByClassName('mtd-select-group').length > 0) {
                    $('.mtd-select-group').each(function () {
                        var activeOption = $(this).find('.active-option')[0];
                        var selectedOption = $(this).find('.selected-option')[0];
                        $(selectedOption).text($(activeOption).text());
                    });
                    $('.mtd-select-group .select-options .select-option').on('click', function () {
                        var dataPlace = $(this).data('place');
                        var parentSelect = $(this).parent().parent();
                        var selectedOption = parentSelect.find('.selected-option')[0];
                        $(selectedOption).html($(this).text()).attr('data-place', $(this).data('place'));
                        $('.mtd-select-group').blur();
                        $('.partner-wrap').removeClass('visible');
                        $('.partner-wrap[data-place="' + dataPlace + '"]').addClass('visible');

                        if (dataPlace === 'all') { 
                            $('.partner-wrap').removeClass('visible');
                            $('.partner-wrap').addClass('visible');
                        }

                        var PDFresponse = $('<div></div>');
                        $('#list-of-partners .visible').each(function(){
                            var header = $($(this).find('h4').get(0)).html();
                            var list = $($(this).find('ul').get(0)).html();
                            PDFresponse.append('<h2>'+header+'</h2>'); 
                            PDFresponse.append('<ul>'+list+'</ul>'); 
                        });

                        $('#list_of_partners_html').val(PDFresponse.html()); 

                        $('.download-pdf-wrap').removeClass('hidden');
                    });

                    $('.mtd-select-group').on('focusin', function (e) {
                        e.preventDefault();
                        $(this).addClass('in');
                    });
                    $('.mtd-select-group').on('focusout', function (e) {
                        e.preventDefault();
                        $(this).removeClass('in');
                    });
                }
            },
            xsScreen: function () {
                function setCollapse() {
                    if (window.innerWidth <= 768) {
                        $('.single-pharmacy-wrap .pharmacy-data h2').attr('data-toggle', 'collapse');
                        $('.single-pharmacy-wrap .pharmacy-data h2').addClass('collapsed');
                        $('.single-pharmacy-wrap .collapse-content').addClass('collapse');
                    } else {
                        $('.single-pharmacy-wrap .pharmacy-data h2').removeAttr('data-toggle');
                        $('.single-pharmacy-wrap .pharmacy-data h2').removeClass('collapsed');
                        $('.single-pharmacy-wrap .collapse-content').removeClass('collapse');
                    }
                }
                setCollapse();
                $(window).resize(function () {
                    setCollapse();
                });
            },
            applyingJob: function () {
                $('#applying_job_title').on('change', function (e) {
                    if (!$(this).hasClass('focused')) {
                        $(this).addClass('focused');
                    }
                    window.location.hash = $(this).find('option:selected').attr('id');
                });
                $('#file').on('change', function (e) {
                    var value = this.files[0].name;
                    $('#file-upload-inner-text').html(value + '<span class="glyphicon glyphicon-ok-circle"></span>');
                });
                $('#file').on('click', function (e) {
                    e.stopPropagation();
                });
                $('.file-upload-button').on('click', function (e) {
                    $('#file').trigger('click');
                });
            },
            newsBoxes: function () {

                $('#news-container').masonry({
                    itemSelector: '.article-wrap',
                    columnWidth: '.article-wrap',
                    gutter: 0,
                    percentPosition: true
                });

                var offset = 4;

                $('.btn-more-news').on('click', function (e) {
                    e.preventDefault();
                    $.ajax({
                        method: 'POST',
                        url: sage.ajaxurl,
                        beforeSend: function () {
                            $('.loading-toolbar').prepend('<div class="loading-bar"><div class="progress-sign"></div></div>');
                        },
                        data: {
                            action: 'get_ajax_posts',
                            offset: offset
                        }
                    }).done(function (response) {
                        if (parseInt(response) !== 0) {

                            parsedHTML = $.parseHTML(response);

                            $('.news-container').append(parsedHTML)
                            .masonry('appended', parsedHTML)
                            .masonry();
                            offset += 4;
                            $('.loading-bar').remove();

                            var num_of_posts = $('<div>' + response + '</div>').find('.article-wrap').length;
                            if (num_of_posts < 5) {
                                $('.loading-toolbar').remove();
                            }

                        } else {
                            $('.loading-toolbar').remove();
                        }
                    });
                });
            },
            menuShowToScroll: function () {
            },
            toggleMenuBtn: function () {

                var keys = {37: 1, 38: 1, 39: 1, 40: 1};

                function preventDefault(e) {
                    e = e || window.event;
                    if (e.preventDefault) {
                        e.preventDefault();
                    }
                    e.returnValue = false;
                }

                function preventDefaultForScrollKeys(e) {
                    if (keys[e.keyCode]) {
                        preventDefault(e);
                        return false;
                    }
                }

                function disableScroll() {
                    if (window.addEventListener) {
                        window.addEventListener('DOMMouseScroll', preventDefault, false);
                    }
                    window.onwheel = preventDefault;
                    window.onmousewheel = document.onmousewheel = preventDefault;
                    window.ontouchmove = preventDefault;
                    document.onkeydown = preventDefaultForScrollKeys;
                }

                function enableScroll() {
                    if (window.removeEventListener) {
                        window.removeEventListener('DOMMouseScroll', preventDefault, false);
                    }

                    window.onmousewheel = document.onmousewheel = null;
                    window.onwheel = null;
                    window.ontouchmove = null;
                    document.onkeydown = null;
                }

                var btn = document.getElementsByClassName('toggle-menu')[0];
                var primaryNav = document.getElementsByClassName('nav-primary')[0];
                btn.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (this.className.indexOf('in') < 0) {
                        this.className = this.className + ' in';
                        primaryNav.className = primaryNav.className + ' in';
                        disableScroll();
                    } else {
                        this.className = this.className.replace(' in', '');
                        primaryNav.className = primaryNav.className.replace(' in', '');
                        enableScroll();
                    }
                });
            },
            finalize: function () {
            }
        },
        'home': {
            init: function () {
                this.scrollIcon();
                this.sizingContactBox();
            },
            sizingContactBox: function () {
                function resizer() {
                    var neighbourHeight = $('.contact-section .career-box').height();
                    $('.contact-section .contact-box').innerHeight(neighbourHeight);
                }
                $(window).resize(function () {
                    resizer();
                });
                resizer();
            },
            scrollIcon: function () {
                var icon = $('.mouse-wheel-animation');
                $(window).scroll(function () {
                    if ($(document).scrollTop() < 100) {
                        icon.removeClass('hidden');
                    } else {
                        icon.addClass('hidden');
                    }
                });
            },
            finalize: function () {

            }
        },

        'about_us': {
            init: function () {

            }
        }
    };

    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            UTIL.fire('common');

            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            UTIL.fire('common', 'finalize');
        }
    };

    $(document).ready(UTIL.loadEvents);

})(jQuery);
